module.exports = __webpack_public_path__ + "img/OYCP_1.6e85d280.jpg";